import { Actions } from '@/config/store.config';
import { Language, normalizeLanguage } from '@/locales';
import router from '@/router';
import store from '@/store';
import productsService from '@/services/menu/products.service';

class LanguageService {
  public async change(language: string): Promise<void> {
    const normalizedLanguage: Language = normalizeLanguage(language);
    if (store.getters.currentLanguage === normalizedLanguage) return;

    await store.dispatch(Actions.SET_LANGUAGE, normalizedLanguage);
    await store.dispatch(Actions.CLEAR_MENU_CACHE);
    const clientId = store.getters.currentFavoriteClientId;
    const refreshes: Promise<unknown>[] = [store.dispatch(Actions.UPDATE_CART)];
    if (clientId) {
      refreshes.push(
        productsService
          .getFavorites(clientId)
          .then((favorites) =>
            store.dispatch(Actions.SET_FAVORITE_PRODUCTS, favorites)
          )
      );
    }
    await Promise.allSettled(refreshes);

    const currentRoute = router.currentRoute.value;
    await router.replace({
      name: currentRoute.name ?? undefined,
      params: currentRoute.params,
      query: currentRoute.query,
      hash: currentRoute.hash,
    });
  }
}

export default new LanguageService();
